import gettext from '@sdk/lang/gettext';
import Spinner from '@sdk/components/ui/Spinner';
import type { TimesheetHistoryItem } from '@sdk/timesheets/types/TimesheetHistory';
import Column from '@sdk/components/ui/spacing/Column';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import { BackButton, Container } from '@web/timeClock/TimesheetHistory/timesheetHistory.styles';
import TimesheetHistoryRows from '@web/timeClock/TimesheetHistoryRows/TimesheetHistoryRows';

type Props = {
  historyItems: TimesheetHistoryItem[];
  back: () => void;
};

const TimesheetHistory = ({ historyItems, back }: Props) => {
  if (!historyItems) {
    return (
      <Column pTop={20} pBottom={20}>
        <Spinner />
      </Column>
    );
  }

  return (
    <Container>
      <TimesheetHistoryRows timesheetHistoryItems={historyItems} />
      <Column pTop={20} pBottom={20} pLeft={20} pRight={20} alignItems="flex-end">
        <BackButton buttonType={ButtonType.default} onClick={back}>
          {gettext('Back')}
        </BackButton>
      </Column>
    </Container>
  );
};

export default TimesheetHistory;
